<template>
  <div id="sve" class="d-flex">
    <MainBarMenuV2 />
    <div class="header-top">
      <div class="container-fluid">
        <HeadingUser />
      </div>
    </div>
    <div class="layout-content container-fluid mt-5">
      <div class="row p-2 mx-auto">
        <div class="col-12 content-title-page">
          <h1>Gestión de la Información Registro de diagnóstico</h1>
          <h2>Nacional</h2>
        </div>
        <div class="col-12 mt-4 mb-4">
          <FilterComponent
            :optionsSVE="optionsSVE"
            :loading="isLoading"
            @submitFilter="submitFilter"
          />
        </div>
        <b-overlay :show="isLoading" rounded="sm">
          <template #overlay>
            <OverlayButton clase="overlay-md"> </OverlayButton>
          </template>
          <div class="col-12 mt-5">
            <div class="row">
              <div class="col-8">
                <GraficBar2
                  refChart="chart-totals"
                  :categories="categoriesTotals"
                  :series="seriesTotals"
                />
              </div>
              <div class="col-4">
                <div class="d-flex flex-column">
                  <div class="d-flex justify-content-between mb-2">
                    <strong>Población total:</strong>
                    {{ data?.total_employees }} personas
                  </div>
                  <div class="d-flex justify-content-between mb-2">
                    <strong>Total Enfermedad Laboral:</strong>
                    {{ data?.total_by_claims?.enfermedad_laboral }} personas
                  </div>
                  <div class="d-flex justify-content-between mb-2">
                    <strong>Total Enfermedad Común:</strong>
                    {{ data?.total_by_claims?.enfermedad_comun }} personas
                  </div>
                  <div class="d-flex justify-content-between mb-2">
                    <strong>Total Accidente Laboral:</strong>
                    {{ data?.total_by_claims?.accidente_laboral }} personas
                  </div>
                  <div class="d-flex justify-content-between mb-2">
                    <strong>Total Accidente Común:</strong>
                    {{ data?.total_by_claims?.accidente_comun }} personas
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr class="hr-filter-info" />
          <div class="col-12 mt-4">
            <div class="row">
              <div class="col-8">
                <GraficLine
                  :series="seriesPrevalence"
                  :labels="labelsPrevalence"
                  title="Prevalencia"
                  refChart="chart-prevelance"
                />
              </div>
              <div class="col-4">
                <div class="d-flex flex-column">
                  <div class="d-flex justify-content-between mb-2">
                    <strong>Prevalencia a nivel nacional:</strong>
                    {{ data?.prevalence?.general_prevalence }}%
                  </div>
                  <div
                    class="d-flex justify-content-between mb-2"
                    v-for="(item, index) in data?.prevalence
                      ?.prevalence_by_location"
                    :key="index"
                  >
                    <strong>{{ item?.location }}:</strong>
                    {{ item?.prevalence }}%
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr class="hr-filter-info" />
          <div class="col-12 mt-4">
            <div class="row">
              <div class="col-8">
                <GraficLine
                  :series="seriesIncidence"
                  :labels="labelsIncidence"
                  title="Incidencia"
                  refChart="chart-incidence"
                />
              </div>
              <div class="col-4">
                <div class="d-flex flex-column">
                  <div class="d-flex justify-content-between mb-2">
                    <strong>Incidencia a nivel nacional:</strong>
                    {{ data?.prevalence?.incidence }}%
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr class="hr-filter-info" />
          <div class="col-12 mt-4">
            <GraficBar
              :series="seriesDiagnostics"
              :categories="diagnostics"
              refChart="chart-diagnostic"
              title="Rating Diagnóstico"
            />
          </div>
          <hr class="hr-filter-info" />
          <div class="col-12 mt-4">
            <div class="row">
              <div class="col-6">
                <GraficPie
                  :labels="labelsClaims"
                  :series="seriesClaims"
                  title="Tipo de siniestro"
                  ref="char-claims"
                />
              </div>
              <div class="col-6">
                <GraficPie
                  :labels="labelsStatus"
                  :series="seriesStatus"
                  title="Estado"
                  ref="char-status"
                />
              </div>
            </div>
          </div>
          <hr class="hr-filter-info" />
          <div class="col-12 mt-4 mb-5">
            <div class="row">
              <div class="col-6">
                <GraficBar
                  :series="series1"
                  :categories="categories1"
                  title=""
                  refChart="chart-1"
                />
              </div>
              <div class="col-6">
                <p>
                  Actualmente, tienes
                  {{ data?.count_by_category?.total_diseases }} enfermedades
                  registradas en tu ubicación:
                </p>
                <ul style="list-style: disc">
                  <li>
                    {{ data?.count_by_category?.investigated }} han sido
                    investigadas.
                  </li>
                  <li>
                    {{ data?.count_by_category?.eps_notification }} cuentan con
                    notificación a la EPS.
                  </li>
                  <li>
                    {{ data?.count_by_category?.furel_uploaded }} tienen el
                    FUREL cargado.
                  </li>
                  <li>
                    {{
                      data?.count_by_category?.ministry_notification_uploaded
                    }}
                    han sido notificadas al Ministerio.
                  </li>
                  <li>
                    Un total de
                    {{ data?.count_by_category?.max_medical_improvement }} casos
                    han logrado una mejoría médica máxima.
                  </li>
                </ul>
                <p>
                  Estos indicadores reflejan el progreso en el manejo de las
                  enfermedades y permiten identificar áreas de mejora en el
                  proceso de gestión de salud.
                </p>
              </div>
            </div>
          </div>
        </b-overlay>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { getStatistics } from "@/services/health-tracker/diagnostic/service";
import MainBarMenuV2 from "@/components/layouts/MainBarMenuV2.vue";
import HeadingUser from "@/components/user/HeadingUser.vue";
import OverlayButton from "@/components/core/overlay/overlay-button.vue";
import FilterComponent from "./components/grafic/FilterComponent.vue";
import GraficBar from "./components/grafic/GraficBar.vue";
import GraficPie from "./components/grafic/GraficPie.vue";
import GraficBar2 from "./components/grafic/GraficBar2.vue";
import GraficLine from "./components/grafic/GraficLine.vue";
export default {
  components: {
    MainBarMenuV2,
    HeadingUser,
    FilterComponent,
    OverlayButton,
    GraficBar,
    GraficPie,
    GraficBar2,
    GraficLine,
  },
  data() {
    return {
      optionsSVE: [],
      seriesPrevalence: [
        {
          name: "Personas",
          type: "column",
          data: [],
        },
        {
          name: "Enfermedad laboral",
          type: "line",
          data: [],
        },
      ],
      labelsPrevalence: [],
      seriesIncidence: [
        {
          name: "Personas",
          type: "column",
          data: [],
        },
        {
          name: "Enfermedad laboral",
          type: "line",
          data: [],
        },
      ],
      labelsIncidence: [],
      seriesTotals: [
        {
          name: "Enfermedad laboral",
          text: "enfermedad_laboral",
          data: [],
        },
        {
          name: "Enfermedad común",
          text: "enfermedad_comun",
          data: [],
        },
        {
          name: "Accidente laboral",
          text: "accidente_laboral",
          data: [],
        },
        {
          name: "Accidente común",
          text: "accidente_comun",
          data: [],
        },
      ],
      categoriesTotals: [],
      categories1: [
        "Mejoría Médica Máxima",
        "Investigadas",
        "Notificación a EPS",
        "Notificación al Ministerio",
        "Furel cargado",
      ],
      series1: [
        {
          name: "",
          data: [0, 0, 0, 0, 0],
        },
      ],
      diagnostics: [],
      seriesDiagnostics: [
        {
          name: "Diagnósticos",
          data: [],
        },
      ],
      labelsClaims: [
        "Accidente Laboral",
        "Accidente Común",
        "Enfermedad Común",
        "Enfermedad Laboral",
      ],
      seriesClaims: [],
      labelsStatus: [],
      seriesStatus: [],
      isLoading: true,
      data: null,
      params: null,
    };
  },
  computed: {
    ...mapState("modSVE", ["sveList"]),
  },
  methods: {
    ...mapActions("modSVE", ["actGetSVElist"]),
    listSVE() {
      this.actGetSVElist().then(() => {
        this.sveList.map((x) => {
          this.optionsSVE.push({
            id: x.id,
            name: x.name,
          });
        });
      });
    },
    async loadStatistics() {
      const me = this;
      //Grafic total
      const seriesTotals = [];
      me.resetGrafics();
      me.isLoading = true;
      try {
        const { data } = await getStatistics(me.params);
        me.data = data;

        const groupMonth = Object.values(data?.group_by_month).flat();
        groupMonth.forEach((x) => {
          const record = seriesTotals.find((y) => y.month === x.month);
          if (record) {
            record.claims.push({
              name: x.claim_type,
              total: x.count,
            });
          } else {
            seriesTotals.push({
              month: x.month,
              claims: [
                {
                  name: x.claim_type,
                  total: x.count,
                },
              ],
            });
          }
        });
        me.categoriesTotals = [];
        seriesTotals.forEach((x) => {
          me.categoriesTotals.push(x.month);
          x.claims.forEach((y) => {
            me.seriesTotals.find((z) => z.text === y.name)?.data.push(y.total);
          });
        });
        //Grafic Prevalence
        data?.prevalence?.prevalence_graph.sort((a, b) => a.year - b.year);
        data?.prevalence?.prevalence_graph.forEach((item) => {
          me.labelsPrevalence.push(item?.year);
          me.seriesPrevalence[0].data.push(item?.people_count);
          me.seriesPrevalence[1].data.push(item?.occupational_diseases_count);
        });
        // ------------------------------------
        //Grafic Prevalence
        data?.prevalence?.incidence_graph.forEach((item) => {
          me.labelsIncidence.push(item?.month);
          me.seriesIncidence[0].data.push(item?.people_count);
          me.seriesIncidence[1].data.push(item?.occupational_diseases_count);
        });
        // ----------------------------------
        //Grafic Diagnostics
        data.diagnostic_ranking.forEach((x) => {
          me.diagnostics.push(x?.code ?? "Sin code");
          me.seriesDiagnostics[0]?.data.push(x.count);
        });
        // ------------------------------------
        //Grafic Status
        data.status.forEach((x) => {
          me.labelsStatus.push(x.status);
          me.seriesStatus.push(x.count);
        });
        //Grafic Claims
        me.seriesClaims = [
          data?.total_by_claims.accidente_laboral
            ? data?.total_by_claims.accidente_laboral
            : 0,
          data?.total_by_claims.accidente_comun
            ? data?.total_by_claims.accidente_comun
            : 0,
          data?.total_by_claims.enfermedad_comun
            ? data?.total_by_claims.enfermedad_comun
            : 0,
          data?.total_by_claims.enfermedad_laboral
            ? data?.total_by_claims.enfermedad_laboral
            : 0,
        ];
        //Grafic series1
        const series1 = [
          data?.count_by_category.max_medical_improvement,
          data?.count_by_category.investigated,
          data?.count_by_category.eps_notification,
          data?.count_by_category.ministry_notification_uploaded,
          data?.count_by_category.furel_uploaded,
        ];
        me.series1 = [
          {
            name: "",
            data: series1,
          },
        ];
      } catch (error) {
        console.log(error);
      } finally {
        me.isLoading = false;
      }
    },
    submitFilter(values) {
      const me = this;
      me.params = { ...values };
      me.loadStatistics();
    },
    resetGrafics() {
      const me = this;
      me.data = null;
      me.labelsStatus = [];
      me.seriesStatus = [];
      me.diagnostics = [];
      me.seriesClaims = [];
      me.seriesDiagnostics = [
        {
          name: "Diagnósticos",
          data: [],
        },
      ];
      me.series1 = [
        {
          name: "",
          data: [0, 0, 0, 0, 0],
        },
      ];
      me.seriesPrevalence = [
        {
          name: "Personas",
          type: "column",
          data: [],
        },
        {
          name: "Enfermedad laboral",
          type: "line",
          data: [],
        },
      ];
      me.labelsPrevalence = [];
      me.seriesIncidence = [
        {
          name: "Personas",
          type: "column",
          data: [],
        },
        {
          name: "Enfermedad laboral",
          type: "line",
          data: [],
        },
      ];
      me.labelsIncidence = [];
      me.seriesTotals[0].data = [];
      me.seriesTotals[1].data = [];
      me.seriesTotals[2].data = [];
      me.seriesTotals[3].data = [];
    },
  },
  mounted() {
    const me = this;
    me.listSVE();
    me.loadStatistics();
  },
};
</script>

<style lang="scss" scoped>
.content-title-page {
  margin-top: 40px;
}
.content-title-page h1 {
  font-weight: 700;
  font-size: 26px;
  color: #37474f;
}
.content-title-page h2 {
  font-weight: 500;
  font-size: 21px;
  color: #78909c;
  padding-left: 20px;
}
.hr-filter-info {
  border-bottom: 1px solid #d8d8d8;
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
